import React from "react";
import { TIPTAP_FIGURE_TYPE } from "./../ricos-content/consts.js";
import { NodeSizeButton } from "./../_shared/node-size-button/node-size-button.js";
import { isVisibleOnlyOnDesktop } from "./../_shared/resolvers/is-visible-only-on-desktop.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common/index.js";
import {
  DeleteButton,
  FLOATING_PLUGIN_TOOLBAR,
  NodeAlignmentButton
} from "./../toolbars-v3/index.js";
import { GIF_BUTTONS, gifModals } from "./constants.js";
import { GiphyInsertModal } from "./modals/InsertModal.js";
const getToolbarButtons = (config, services) => {
  const {
    context: { isMobile }
  } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(
        NodeSizeButton,
        {
          id: GIF_BUTTONS.size,
          toolbarItem,
          options: ["SMALL", "CONTENT", "FULL_WIDTH", "ORIGINAL"]
        }
      )
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: isVisibleOnlyOnDesktop(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: GIF_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: isVisibleOnlyOnDesktop(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      attributes: {
        active: {
          resolve: (_, { modals }) => Boolean(modals.getModal(gifModals.replace))
        }
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        const { modals } = services;
        modals?.togglePluginPanel({
          id: gifModals.replace,
          Component: GiphyInsertModal,
          componentProps: {
            nodeId: selectedNode.attrs.id,
            modalId: gifModals.replace,
            getGiphyUrl: config?.getGiphyUrl
          },
          positioning: {
            referenceElement: referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: "right-start"
          },
          isMobile: isMobile2,
          focusReturnElement: referenceElement
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
      renderer: (toolbarItem) => {
        return /* @__PURE__ */ React.createElement(DeleteButton, { toolbarItem });
      },
      command: (data) => {
        const figures = data.tiptapEditor.$nodes(TIPTAP_FIGURE_TYPE);
        const selectedFigure = figures?.find((f) => {
          return f.firstChild?.node.attrs.id === data.attributes.selectedNode.attrs.id;
        });
        if (selectedFigure) {
          data.tiptapEditor.chain().focus().deleteNode(selectedFigure.attributes.id).run();
        }
      }
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
